import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import MDButton from "components/MDButton";
import { useAlerta } from "utils/alertas";
import Grid from "@mui/material/Grid";

export default function AgregarCarreraModal({ open, onClose, onCarreraAgregada }) {
  const [institucion, setInstitucion] = useState("");
  const [nombre, setNombre] = useState("");
  const [duracion, setDuracion] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [tipo, setTipo]= useState("");
  const [incluyeTexto, setIncluyeTexto] = useState(false);
  const [estado, setEstado] = useState(1);
  const [loading, setLoading] = useState(false);
  const { mostrarAlerta } = useAlerta();

  const token = sessionStorage.getItem("access_token");

  const handleSubmit = async () => {
    setLoading(true);

    const payload = {
      nombre: nombre || null,
      duracion: duracion || null,
      fecha_inicio: fechaInicio || null,
      tipo: tipo || null,
      incluye_texto: incluyeTexto,
      estado,
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/carreras`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      mostrarAlerta("Carrera Creada correctamente","success");

      if (!res.ok) {
        console.error("Error del servidor:", data);
        throw new Error(data.message || "Error al guardar carrera");
      }

      onCarreraAgregada(data);
      onClose();

      // limpiar campos
      setInstitucion("");
      setNombre("");
      setDuracion("");
      setFechaInicio("");
      setTipo("");
      setIncluyeTexto(false);
      setEstado(1);
    } catch (err) {
      console.error("Error al agregar carrera:", err);
      mostrarAlerta(
        error.message || "Error al guardar la carrera",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // padding responsive
          width: { xs: '90%', sm: 400, md: 500 }, // 🔥 clave
          maxHeight: '90vh', // evita que se salga de pantalla
          overflowY: 'auto', // scroll interno
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h6" mb={2}>
          Agregar Carrera
        </Typography>

        <TextField
          fullWidth
          label="Nombre"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          sx={{ mb: 2 }}
        />

        <Grid container spacing={2} sx={{ mb: 2 }}>
          {/* TIPO */}
          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              label="Tipo"
              value={tipo}
              onChange={(e) => {
                setTipo(e.target.value);
                setDuracion(""); // reset duración cuando cambia tipo
              }}
              SelectProps={{ native: true }}
            >
              <option value=""></option>
              <option value="anual">Anual</option>
              <option value="semestral">Semestral</option>
            </TextField>
          </Grid>

          {/* DURACIÓN DINÁMICA */}
          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              label="Duración"
              value={duracion}
              onChange={(e) => setDuracion(e.target.value)}
              SelectProps={{ native: true }}
              disabled={!tipo}
            >
              <option value=""></option>

              {tipo === "anual" && (
                <>
                  <option value="2">2 años</option>
                  <option value="3">3 años</option>
                </>
              )}

              {tipo === "semestral" && (
                <>
                  <option value="4">4 semestres</option>
                  <option value="6">6 semestres</option>
                </>
              )}
            </TextField>
          </Grid>
        </Grid>
        <TextField
          fullWidth
          type="date"
          label="Fecha de Inicio"
          value={fechaInicio}
          onChange={(e) => setFechaInicio(e.target.value)}
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
        />

        <MDButton
          variant="contained"
          color="info"
          fullWidth
          onClick={handleSubmit}
          disabled={loading}
          sx={{ color: "#fff" }}
        >
          {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Agregar"}
        </MDButton>
      </Box>
    </Modal>
  );
}
